__turbopack_context__.v({
  "outlined": "IconButton-module__cRDHBW__outlined",
  "root": "IconButton-module__cRDHBW__root",
});
